import { render, staticRenderFns } from "./CompanyIcon.vue?vue&type=template&id=ad623e30"
import script from "./CompanyIcon.vue?vue&type=script&lang=js"
export * from "./CompanyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports